import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';
import 'mobx-react-lite/batchingForReactDom';

import * as serviceWorker from './serviceWorker';

import App from 'App';

import 'styles/reboot.css';


ReactDOM.render(
    <Router>
        <App/>
    </Router>,
    document.getElementById('app-root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
